// extracted by mini-css-extract-plugin
var _1 = "nextPaymentAmount";
export { _1 as "nextPaymentAmount" }
export default { "nextPaymentAmount": _1 }
